// Central content & contact data for Portail du Léman
export const COMPANY = {
    name: "Portail du Léman",
    tagline: "L'élégance d'une entrée, la sécurité d'une propriété",
    shortPitch: "Portails, clôtures et brise-vue sur mesure autour du Léman",
    address: {
        street: "1103 Grand Route",
        postalCode: "01630",
        city: "Saint-Jean-de-Gonville",
        country: "France",
    },
    phones: [
        { label: "France", value: "+33 6 10 44 38 64", tel: "+33610443864" },
        { label: "Suisse", value: "+41 76 222 36 03", tel: "+41762223603" },
    ],
    email: "info@portailduleman.com",
    website: "https://www.portailduleman.com",
    logo: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/pa4obomx_f28e4e74-855c-4568-a5eb-2254b2f40cf7.png",
    logoHero: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/zjga7kbx_ChatGPT%20Image%2028%20juin%202026%2C%2013_33_29.png",
    texture: "https://customer-assets.emergentagent.com/job_a14dabab-c52d-4150-8a9b-dc0b4b37acd3/artifacts/xqftkdte_3.JPG",
    areas: [
        "Saint-Jean-de-Gonville", "Thoiry", "Gex", "Ferney-Voltaire", "Divonne-les-Bains",
        "Prévessin-Moëns", "Ornex", "Cessy", "Sergy", "Crozet",
        "Saint-Genis-Pouilly", "Annemasse", "Saint-Julien-en-Genevois",
        "Genève", "Vaud", "La Côte", "Nyon", "Coppet", "Rolle", "Morges",
        "Haute-Savoie", "Pays de Gex", "Bassin lémanique",
    ],
};

export const PROJECT_TYPES = [
    "Portail aluminium",
    "Portail coulissant",
    "Portail battant",
    "Motorisation de portail",
    "Clôture",
    "Brise-vue / Claustra",
    "Contrôle d'accès / Interphone",
    "Autre projet",
];

// Image bank (assets fournis par le client + Unsplash secondaires)
export const IMG = {
    hero: "https://images.unsplash.com/photo-1613850011958-cfb3e7364058?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob21lJTIwZW50cmFuY2UlMjBnYXRlfGVufDB8fHx8MTc4MjU5MjMxOXww&ixlib=rb-4.1.0&q=85",
    gateAlu: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/2gbpmy8a_portail%20alu.png",
    gateAlu2: "https://images.unsplash.com/photo-1645005049035-c35644b627ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhbHVtaW5pdW0lMjBnYXRlfGVufDB8fHx8MTc4MjU5MjMxOHww&ixlib=rb-4.1.0&q=85",
    metalFence: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/zwmr5c70_cloture.png",
    entrance: "https://images.unsplash.com/photo-1768162485770-d1cf65960e32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBob21lJTIwZW50cmFuY2UlMjBnYXRlfGVufDB8fHx8MTc4MjU5MjMxOXww&ixlib=rb-4.1.0&q=85",
    villa: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1600&q=80",
    leman: "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?auto=format&fit=crop&w=1600&q=80",
    motor: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/pvs1obiw_motorisation.png",
    briseVue: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/tff3wc2e_claustra.png",
    workshop: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/770vgbtx_pose%20de%20portail.png",
};
